<div class="wysiwyg-editor" [class.wysiwyg-editor--plain-text]="plainText"
     [attr.role]="(ariaLabelledby || ariaLabel) ? 'group' : null"
     [attr.aria-labelledby]="ariaLabelledby || null"
     [attr.aria-label]="ariaLabelledby ? null : (ariaLabel || null)">
    <div class="wysiwyg-editor__toolbar-row">
        <ngx-editor-menu *ngIf="!isHtmlMode && !plainText" [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
        <div *ngIf="isHtmlMode || plainText" class="wysiwyg-editor__spacer"></div>

        <!-- Custom toolbar buttons -->
        <div class="wysiwyg-editor__custom-buttons" *ngIf="templateVariables.length > 0 || showHtmlToggle">
            <!-- Insert Variable Dropdown -->
            <button
                *ngIf="templateVariables.length > 0"
                type="button"
                class="wysiwyg-editor__btn wysiwyg-editor__btn--icon"
                [matMenuTriggerFor]="variableMenu"
                aria-label="Insert variable">
                <mat-icon>data_object</mat-icon>
            </button>
            <mat-menu #variableMenu="matMenu" xPosition="before" class="wysiwyg-variable-menu">
                <button
                    mat-menu-item
                    *ngFor="let variable of templateVariables"
                    (click)="insertVariable(variable.value)">
                    {{ variable.label }}
                </button>
            </mat-menu>

            <!-- Toggle HTML Source Button -->
            <button
                type="button"
                *ngIf="showHtmlToggle"
                class="wysiwyg-editor__btn wysiwyg-editor__btn--icon"
                [class.wysiwyg-editor__btn--active]="isHtmlMode"
                (click)="toggleHtmlMode()"
                [attr.aria-pressed]="isHtmlMode"
                aria-label="Toggle HTML source">
                <mat-icon>code</mat-icon>
            </button>
        </div>
    </div>

    <!-- WYSIWYG Editor -->
    <ngx-editor
        *ngIf="!isHtmlMode"
        [editor]="editor"
        [(ngModel)]="content"
        [placeholder]="placeholder"
        (ngModelChange)="onContentChange($event)">
    </ngx-editor>

    <!-- Raw HTML Textarea -->
    <textarea
        *ngIf="isHtmlMode"
        class="wysiwyg-editor__html-source"
        [(ngModel)]="rawContent"
        [placeholder]="placeholder"
        [attr.aria-labelledby]="ariaLabelledby || null"
        [attr.aria-label]="ariaLabelledby ? null : (ariaLabel || null)"
        (ngModelChange)="onHtmlContentChange($event)">
    </textarea>
</div>
